import { create } from 'zustand';
import { Brand, BrandTheme } from '../../modules/settings/brand/types/brand';
import { createJSONStorage, persist, StateStorage } from 'zustand/middleware';

type BrandState = {
  brand: Brand | null;
  theme: BrandTheme;
  hasLoaded: boolean;
  setBrand: (brand: Brand | null) => void;
  setTheme: (theme: Partial<BrandTheme>) => void;
  setHasLoaded: (value: boolean) => void;
};

const noopStorage: StateStorage = {
  getItem: () => null,
  setItem: () => {},
  removeItem: () => {},
};

export const useBrandStore = create<BrandState>()(
  persist(
    set => ({
      brand: null,
      theme: 'volcan',
      hasLoaded: false,
      setBrand: brand =>
        set({
          brand,
          theme: brand?.theme,
        }),
      setTheme: theme =>
        set(state => ({
          ...state,
          theme,
        })),
      setHasLoaded: value => set({ hasLoaded: value }),
    }),
    {
      name: 'brand-store',
      storage: createJSONStorage(() =>
        typeof window !== 'undefined' ? window.localStorage : noopStorage,
      ),
    },
  ),
);
